import { Box, Grid, Paper } from "@mui/material";
import { useState } from "react";
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import MenuFrame from "./frames/menu_frame";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import "./dashboard.css"
import { useLanguage } from "./LanguageContext";

const Dashboard = () => {
  const { text } = useLanguage();
  const apps = [
    { name: text("counter_booking"), description: "Consignment booking at outlet counter", image: "/img/desk1.png", link: "/desk-booking" },
    { name: text("corporate_booking"), description: "Corporate client consignment booking", image: "/img/booking.png", link: "/org-booking" },
    { name: text("pickup"), description: "Corporate client consignment pickup", image: "/img/pickup2.png", link: "/pickup-booking" },
    { name: text("packaging"), description: "Corporate client consignment packaging", image: "/img/packaging.png", link: "/packaging-booking" },
    { name: text("insurance"), description: "Insurance service by DTDC Express", image: "/img/insurance.png", link: "/insurance" },
    { name: text("correction"), description: "Edit consignment details for Corporate and Desk", image: "/img/edit3.png", link: "/correction/home" },
    { name: text("billing"), description: "Corporate billing and invoice genration", image: "/img/invoice1.png", link: "/billing" },
    { name: text("invoices"), description: "Invoice list and operations", image: "/img/invoice.png", link: "/invoices" },
    { name: text("accounts"), description: "FinOps account management tool", image: "/img/accounts1.png", link: "/accounts" },
    { name: text("users"), description: "User access management", image: "/img/user.png", link: "/users" },
    { name: text("employee"), description: "Employee resource management", image: "/img/employee.png", link: "/employee" },
    { name: text("clients"), description: "Client resource management", image: "/img/company2.png", link: "/client" },
    { name: text("vendor"), description: "Vendor resource management", image: "/img/company1.png", link: "/vendor" },
    { name: text("quotation"), description: "Create quotation for client", image: "/img/quote.png", link: "/quotation" },
    { name: text("finops"), description: "", image: "/img/finops.png", link: "/fin-ops" },
    { name: text("admin"), description: "", image: "/img/settings.png", link: "/admin" },
    { name: text("inventory"), description: "", image: "/img/inventory.png", link: "/inventory" },
    { name: text("reports"), description: "", image: "/img/report1.png", link: "/reports" },
    { name: text("letter_head"), description: "", image: "/img/seal.png", link: "/latter-head" },
    { name: text("Excel"), description: "", image: "/img/excel.png", link: "/fin-ops/excel" },
    // { name: "Receivable", description: "", image: "/img/receivable.png", link: "/receivable" },
    // { name: "External Links", description: "List of external link", image: "/img/link.png", link: "/external-links" },
  ]
  const [appList, setAppList] = useState(apps);
  const navigator = useNavigate();

  const handleSearch = (e) => {
    const txt = e.target.value.trim().toLowerCase();
    if (txt === "") setAppList(apps);
    setAppList(apps.filter((i) => i.description.toLowerCase().includes(txt)));
  }

  return (
    <MenuFrame onSearch={handleSearch} screen="DASHBOARD">
      <Grid container spacing={2} sx={{ mt: 2, mb: 2 }}>
        {appList.map((val, idx) => {
          return (
            <Grid size={{ xs: 4, sm: 3 }} key={idx} component={Paper} >
              <Box onClick={() => { navigator(val.link) }} style={{ cursor: "pointer", height: "100%" }}>
                <motion.div whileHover={{ scale: 1.05 }} style={{ height: "100%" }}>
                  <Tooltip title={val.description}>
                    <div className="dashboard-item" style={{ minWidth: 100, background: "linear-gradient(" + (45 + idx * 90) + "deg, rgba(212, 233, 254, 1) 0%, rgb(142, 231, 255) 35%, rgb(125, 233, 255) 100%)" }}>
                      <img src={val.image} alt={val.description} loading="lazy" style={{ margin: "25px", width: "50px", height: "50px", maxWidth: "90%", maxHeight: "90%" }} /><br />
                      <Typography variant="subtitle2">{val.name}</Typography>
                    </div>
                  </Tooltip>
                </motion.div>
              </Box>
            </Grid>
          )
        })}
      </Grid>
    </MenuFrame>
  );
};

export default Dashboard;
